import { render, staticRenderFns } from "./BriqMultilanguageWarningModal.vue?vue&type=template&id=5cd4c200&scoped=true&lang=pug&"
import script from "./BriqMultilanguageWarningModal.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguageWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./BriqMultilanguageWarningModal.vue?vue&type=style&index=0&id=5cd4c200&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4c200",
  null
  
)

export default component.exports